<template>
  <div>
    <CDropdown
      inNav
      class="c-header-nav-items"
      placement="bottom-end"
      add-menu-classes="py-0"
    >
      <template #toggler>
        <CHeaderNavLink>
          <div class="c-avatar">
            <img :src="getUrlImg" class="c-avatar-img" />
          </div>
        </CHeaderNavLink>
      </template>
      <CDropdownHeader tag="div" class="text-center" color="light">
        <strong>Conta</strong>
      </CDropdownHeader>

      <CDropdownItem to="/configuracoes/informacoes_pessoas">
        <CIcon name="cil-user" /> Dados pessoais
      </CDropdownItem>
      <CDropdownItem>
        <CIcon name="cil-bell" /> Notificações
        <div slot="default"></div>
      </CDropdownItem>
      <!--
    <CDropdownItem>
      <CIcon name="cil-dollar" /> Payments
      <CBadge
        color="secondary"
        class="ml-auto"
      >{{ itemsCount }}</CBadge>
    </CDropdownItem>
    -->
      <CDropdownItem to="/solicitar/solicitacoes" v-if="getTipo == 'CO'">
        <CIcon name="cil-bike" /> Solicitações

        <!--<CBadge
          color="primary"
          class="ml-auto"
        >{{ itemsCount }}</CBadge>-->
      </CDropdownItem>
      <CDropdownItem
        to="/controle/solicitacao_detalhes"
        v-else-if="getTipo == 'SA' || getTipo == 'AD'"
      >
        <CIcon name="cil-bike" /> Solicitações

        <!--<CBadge
          color="primary"
          class="ml-auto"
        >{{ itemsCount }}</CBadge>-->
      </CDropdownItem>
      <!--<CDropdownDivider class="mb-0" />-->

      <CDropdownItem class="p-0 my-0">
        <div style="flex: auto" slot="default">
          <CButton
            class="p-0"
            icon="true"
            size="lg"
            style="min-height: 40px"
            :block="true"
            @click="warningModal = true"
          >
            <CIcon name="cil-account-logout" />

            Sair
          </CButton>
        </div>
      </CDropdownItem>
    </CDropdown>

    <CModal
      title="Deseja sair do sistema ?"
      variant="warning"
      color="warning"
      :centered="true"
      :show.sync="warningModal"
    >
      Ao sair notificações não serão entregues
      <div slot="footer">
        <CRow>
          <CCol cols="1">
            <CButton color="primary" @click="warningModal = false"
              >Cancelar</CButton
            >
          </CCol>
          <CCol cols="1">
            <CButton color="success" @click="logout()">Sair</CButton>
          </CCol>
        </CRow>
      </div>
    </CModal>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      itemsCount: 0,
      warningModal: false,
      notif: [],

      qnt: 0,
    };
  },

  created() {
    if (
      window.location.hostname == "bikersecodelivery.com.br" ||
      window.location.hostname == "www.bikersecodelivery.com.br"
    ) {
      this.url = "https://laravel.bikersecodelivery.com.br";
    } else if (window.location.hostname == "teste.bikersecodelivery.com.br") {
      this.url = "https://teste-laravel.bikersecodelivery.com.br";
    } else if (window.location.hostname == "localhost") {
      this.url = "http://127.0.0.1:8000";
    }

    // this.url = "https://laravel.bikersecodelivery.com.br";
    this.qnt = null;
    sessionStorage.setItem("url", this.url);
    // this.url = "https://laravel.bikersecodelivery.com.br";

    if (this.getToken) {
      axios
        .get(sessionStorage.getItem("url") + "/api/usuario-autenticado", {
          headers: { Authorization: "Bearer " + this.getToken },
        })
        .then((response) => {
          if (response.data.status == "Token is Expired") {
            this.$store.commit("DESTROY_USER");
            this.$router.push("/");
          }
          this.$store.commit("SET_USER", response.data);
          this.atualiza_notificacoes(response.data.id);
          if (response.data.desativado == 1) {
            this.$router.push("/");
          }
          if (response.data.desativado == 2) {
            this.$router.push("/configuracoes/informacoes_pessoas");
          }
          this.carregouImg = true;
          this.initialize;
        });
    } else {
      this.logout();
    }
  },

  methods: {
    visualiza_todas() {
      var n = Array.from(this.notif);

      n.forEach((element) => {
        this.qnt = null;
        this.visualiza(element);
      });
      this.atualiza_notificacoes();
      this.notif.splice(0, this.notif.length);
    },
    open_notification(item) {
      this.visualiza(item);
    },
    visualiza(item) {
      var obj = Object.assign({}, this.notif);
      var arr = [];

      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          var innerObj = {};
          innerObj[prop] = obj[prop];
          arr.push(innerObj[prop].idNotificacao);
        }
      }

      item.lista = arr;
      console.log(arr);

      axios
        .post(
          sessionStorage.getItem("url") + "/api/visualiza-notificacao",
          item,
          {
            headers: { Authorization: "Bearer " + this.getToken },
          }
        )
        .then((response) => {
          if (response.data.status == "Token is Expired") {
            this.$store.commit("DESTROY_USER");
            this.$router.push("/");
          }
          if (item.redirect != null) {
            this.$router.push(item.redirect);
            this.qnt = null;
          }
        });
    },

    atualiza_notificacoes() {
      if (this.getToken) {
        axios
          .get(
            sessionStorage.getItem("url") + "/api/notificacoes-usuario/normal",
            {
              headers: { Authorization: "Bearer " + this.getToken },
            }
          )
          .then((response) => {
            if (response.data.status == "Token is Expired") {
              this.$store.commit("DESTROY_USER");
              this.$router.push("/");
            }
            this.qnt = response.data.qnt;
            this.notif = response.data.notif;
          });
        if (this.getTipo != "CO") {
          axios
            .get(sessionStorage.getItem("url") + "/api/count-solicitacoes", {
              headers: { Authorization: "Bearer " + this.getToken },
            })
            .then((response) => {
              if (response.data.status == "Token is Expired") {
                this.$store.commit("DESTROY_USER");
                this.$router.push("/");
              }
              this.qnt2 = response.data;
            });
        }
      }
    },
    logout() {
      this.close_websocket();
      this.$store.commit("DESTROY_USER");
      this.$router.push("/");
      this.$forceUpdate();
    },
    async close_websocket() {
      if (this.$socket != null) {
        await this.$socket.client.emit("vue_disconect");
        await this.$socket.client.close();

        this.$socket = null;
      }
    },
  },
  computed: {
    getUrlImg() {
      if (this.getFotoPerfil != null && this.getFotoPerfil != "") {
        return this.url + "/storage/" + this.getFotoPerfil;
      } else {
        return require("@/assets/default2.jpg").default;
      }
    },
    verificaTipo() {
      if (
        this.$store.getters.getTipo == "PE" ||
        this.$store.getters.getTipo == "MT"
      ) {
        return true;
      }
      if (
        this.$store.getters.getTipo == "AD" ||
        this.$store.getters.getTipo == "SA"
      ) {
        if (this.$store.getters.getNotificaSolicitacao == 1) return true;
      }
      return false;
    },
    getLogado() {
      return this.$store.getters.getLogado;
    },
    getDesativado() {
      return this.$store.getters.getDesativado;
    },
    getNome() {
      return this.$store.getters.getNome;
    },
    getFotoPerfil() {
      return this.$store.getters.getFotoPerfil;
    },
    getId() {
      if (this.$store.getters.getTipo != "CO")
        return "#" + this.$store.getters.getId;
      return null;
    },
    getNome() {
      return this.$store.getters.getNome;
    },
    getTipo() {
      return this.$store.getters.getTipo;
    },
    getToken() {
      return this.$store.getters.getToken;
    },
    getPadding() {
      if (this.$route.name != "Login") return "pt-5";
      else return "";
    },
  },
};
</script>

<style lang="css">
.menu {
  margin: 0px;
  min-width: 500px;
  max-height: 50rem;
  position: absolute;
  left: 0px;
  top: 0px;
  right: auto;
  bottom: auto;
  height: auto;
  overflow-x: hidden;
  /* transform: translate(-283px, 16px); */
}
</style>
<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>
